import React, { useEffect, useMemo, useState } from 'react';
import DeleteModal from '../../components/DeleteModal';
import TableContainer from '../../components/TableContainer';
import { useDispatch } from 'react-redux';
import withRouter from '../../components/withRouter';
import { createApiKey, getApiKeys, updateApiKey } from '../../api/apiKeyApi';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { APIKeys } from '../../types/api-key';
import { format } from 'date-fns';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

const Index = () => {
    document.title = 'API Key';
    const dispatch: any = useDispatch();
    const [show, setShow] = useState<boolean>(false);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteModalMulti, setDeleteModalMulti] = useState<boolean>(false);
    const [data, setData] = useState<APIKeys[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedApiKey, setSelectedApiKey] = useState<APIKeys>();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        getApiKeys().then(setData);
    }, []);

    const onClickDelete = () => {
        setDeleteModal(true);
    };

    const checkedAll = () => {
        const checkAll: any = document.getElementById('checkBoxAll');
        const elements = document.querySelectorAll('.orderCheckBox');

        if (checkAll.checked) {
            elements.forEach((element: any) => {
                element.checked = true;
            });
        } else {
            elements.forEach((element: any) => {
                element.checked = false;
            });
        }
    };
    const columns = useMemo(
        () => [
            {
                header: (
                    <input
                        type="checkbox"
                        id="checkBoxAll"
                        className="form-check-input"
                        onClick={() => checkedAll()}
                    />
                ),
                cell: (cell: any) => {
                    return (
                        <input
                            type="checkbox"
                            className="orderCheckBox form-check-input"
                            value={cell.getValue()}
                        />
                    );
                },
                id: '#',
                accessorKey: 'id',
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: 'Nome',
                accessorKey: 'name',
                enableColumnFilter: false,
                cell: (cell: any) => {
                    return cell.getValue() ? cell.getValue() : "";
                },
            },
            {
                header: 'API Key',
                accessorKey: 'token',
                enableColumnFilter: false,
                border: '1px solid black',
                cell: (cell: any) => {
                    return <input type="text" className="form-control apikey-value" readOnly
                                  defaultValue={cell.getValue()} {...cell} />;
                },
            },
            {
                header: 'Status',
                accessorKey: 'isActive',
                enableColumnFilter: false,
                cell: (cell: any) => {
                    switch (cell.getValue()) {
                        case true:
                            return <span className="badge bg-success-subtle text-success"> Ativo </span>;
                        case false:
                            return <span className="badge bg-danger-subtle text-danger"> Desativado </span>;
                        default:
                            return <span className="badge bg-success-subtle text-success"> {cell.getValue()} </span>;
                    }
                },
            },
            {
                header: 'Criação',
                accessorKey: 'createdAt',
                enableColumnFilter: false,
                cell: (cell: any) => {
                    return cell.getValue() ? format(cell.getValue(), 'dd/MM/yyyy HH:mm:ss XXX') : '';
                },
            },
            {
                header: 'Última utilização',
                accessorKey: 'lastUsedAt',
                enableColumnFilter: false,
                cell: (cell: any) => {
                    return cell.getValue() ? format(cell.getValue(), 'dd/MM/yyyy HH:mm:ss XXX') : '-';
                },
            },
            {
                header: 'Data de Expiração',
                accessorKey: 'expiresAt',
                enableColumnFilter: false,
                cell: (cell: any) => {
                    const expiresAt = cell.getValue();
                    if (!expiresAt) return 'ilimitado';
                    const isExpired = new Date(expiresAt) < new Date();
                    const formattedDate = format(expiresAt, 'dd/MM/yyyy HH:mm:ss XXX');
                    return isExpired ? (
                        <span className="badge bg-danger-subtle text-danger">{formattedDate} (vencido)</span>
                    ) : (
                        formattedDate
                    );
                },
            },
            {
                header: 'Ação',
                disableFilters: true,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <UncontrolledDropdown className="dropdown">
                            <DropdownToggle
                                role="button"
                                tag="button"
                                className="btn btn-soft-secondary btn-sm dropdown"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <i className="ri-more-fill align-middle"></i>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu dropdown-menu-end">
                                <li>
                                    <DropdownItem
                                        className="edit-item-btn"
                                        to="#api-key-modal"
                                        data-bs-toggle="modal"
                                    >
                                        Renomear
                                    </DropdownItem>
                                </li>
                                <li>
                                    <DropdownItem
                                        className="regenerate-api-btn"
                                        to="#api-key-modal"
                                        data-bs-toggle="modal"
                                    >
                                        Gerar nova chave
                                    </DropdownItem>
                                </li>
                                <li>
                                    <DropdownItem className="disable-btn" to="#">
                                        {cell.row.original.isEnabled ? "Desabilitar" : "Habilitar"}
                                    </DropdownItem>
                                </li>
                                <li>
                                    <DropdownItem
                                        className="remove-item-btn"
                                        onClick={() => {
                                            onClickDelete();
                                        }}
                                        to="#deleteApiKeyModal"
                                    >
                                        Deletar
                                    </DropdownItem>
                                </li>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    );
                },
            },
        ],
        [],
    );

    const handleAddData = (newData: APIKeys) => {
        setData([...data, newData]);
    };

    const handleForm: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: selectedApiKey?.id || '',
            name: selectedApiKey?.name || '',
        },
        validationSchema: Yup.object({
            name: Yup.string().trim().required('Nome é obrigatório'),
        }),
        onSubmit: (values: any) => {
            setLoading(true);

            if (selectedApiKey) {
                updateApiKey(values)
                    .then((res: any) => {
                        handleClose();
                        toast.success('API Key editada com sucesso!');
                        handleAddData(res);
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            } else {
                createApiKey(values)
                    .then((res: any) => {
                        handleClose();
                        toast.success('API Key cadastrada com sucesso!');
                        handleAddData(res);
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        },
    });

    return (
        <React.Fragment>
            <div className="page-content">
                <DeleteModal
                    show={deleteModal}
                    onCloseClick={() => setDeleteModal(false)}
                />
                <DeleteModal
                    show={deleteModalMulti}
                    onDeleteClick={() => {
                        setDeleteModalMulti(false);
                    }}
                    onCloseClick={() => setDeleteModalMulti(false)}
                />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card" id="apiKeyList">
                                <div className="card-header d-flex align-items-center">
                                    <h5 className="card-title flex-grow-1 mb-0">API Keys</h5>
                                    <div className="d-flex gap-1 flex-wrap">
                                        <button
                                            type="button"
                                            className="btn btn-primary create-btn"
                                            data-bs-toggle="modal"
                                            onClick={handleShow}
                                            data-bs-target="#api-key-modal"
                                        >
                                            <i className="ri-add-line align-bottom me-1"></i> Add API Key
                                        </button>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div>
                                        <TableContainer
                                            columns={columns}
                                            data={data || []}
                                            customPageSize={8}
                                            divClass="table-responsive table-card mb-3"
                                            tableClass="table align-middle table-nowrap mb-0"
                                            theadClass="table-light"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal */}
            <div
                className={`modal fade${show ? ' show d-block' : ''}`}
                id="api-key-modal"
                aria-labelledby="exampleModalLabel"
                aria-hidden={!show}
                tabIndex={-1}
                style={show ? { background: 'rgba(0,0,0,0.5)' } : {}}
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <form onSubmit={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleForm.handleSubmit();
                            return false;
                        }}>
                            <div className="modal-header">
                                <h5 className="modal-title">Criar API Key</h5>
                                <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
                            </div>
                            <div className="modal-body">
                                <div
                                    id="api-key-error-msg"
                                    className="alert alert-danger py-2 d-none"
                                ></div>
                                <div className="mb-3">
                                    <label htmlFor="api-key-name" className="form-label">
                                        API Key Nome <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control${handleForm.touched.name && handleForm.errors.name ? ' is-invalid' : ''}`}
                                        id="name"
                                        name="name"
                                        placeholder="Digite o nome da api key"
                                        onChange={handleForm.handleChange}
                                        onBlur={handleForm.handleBlur}
                                        value={handleForm.values.name}
                                    />
                                    {handleForm.touched.name && handleForm.errors.name ? (
                                        <div className="invalid-feedback">{handleForm.errors.name}</div>
                                    ) : null}
                                </div>
                                {selectedApiKey && (
                                    <div className="mb-3" id="apikey-element" style={{ display: 'none' }}>
                                        <label htmlFor="api-key" className="form-label">
                                            API Key
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="api-key"
                                            disabled
                                            value={selectedApiKey.token}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <div className="hstack gap-2 justify-content-end">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                        onClick={handleClose}
                                    >
                                        Fechar
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        id="createApi-btn"
                                    >
                                        Criar API
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default withRouter(Index);
